/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Pii_WarningInputs */



/**
* | output |
* | --- |
* | "Contains personal data: names, email addresses, phone numbers, Discord handles and disciplinary records." |
*
* @param {Admin_Export_Pii_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_export_pii_warning = /** @type {((inputs?: Admin_Export_Pii_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Pii_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contient des données personnelles : noms, adresses email, numéros de téléphone, noms d'utilisateur Discord et sanctions.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contiene datos personales: nombres, direcciones de correo electrónico, números de teléfono, nombres de usuario de Discord y sanciones.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Contém dados pessoais: nomes, endereços de e-mail, números de telefone, nomes de usuário do Discord e sanções.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contiene dati personali: nomi, indirizzi email, numeri di telefono, nomi utente Discord e sanzioni.")
	return /** @type {LocalizedString} */ ("Contains personal data: names, email addresses, phone numbers, Discord handles and disciplinary records.")
});